// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TsvJ","footer":"styles_footer__3ThOK"};